import React, { useState, useEffect } from 'react';
import ScheduleMemoModal from '../components/ScheduleMemoModal';
import CustomAlert from '../components/CustomAlert';
import useCustomAlert from '../hooks/useCustomAlert';
import { getAllSchedules, subscribeToSchedules, subscribeToMemos, addMemo, updateScheduleStatus, updateMemoStatus, deleteMemo, updateMemo } from '../services/firestoreService';
import '../styles/Home.css';

// 공통 날짜 계산 함수 (관리자 기준 - 월요일 시작)
const getWeekCalculation = (baseDate = new Date()) => {
  console.log('🗓️ Home.js - 공통 날짜 계산 함수 실행됨!', baseDate);
  
  const today = new Date(baseDate);
  const currentDay = today.getDay(); // 0: 일요일, 1: 월요일, ..., 6: 토요일
  
  // 이번 주 월요일 계산 (월요일을 주의 시작으로 함)
  const mondayOffset = currentDay === 0 ? -6 : 1 - currentDay; // 일요일인 경우 -6, 나머지는 1-currentDay
  const monday = new Date(today);
  monday.setDate(today.getDate() + mondayOffset);
  monday.setHours(0, 0, 0, 0);
  
  // 다음 주 월요일 계산
  const nextMonday = new Date(monday);
  nextMonday.setDate(monday.getDate() + 7);
  
  // 각 요일별 날짜 계산
  const weekDates = {};
  const dayIds = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
  dayIds.forEach((dayId, index) => {
    const date = new Date(monday);
    date.setDate(monday.getDate() + index);
    weekDates[dayId] = date;
  });
  
  return {
    monday,
    nextMonday,
    weekDates,
    formatDate: (date) => `${date.getMonth() + 1}/${date.getDate()}`,
    getDateForDayOfWeek: (dayOfWeek) => {
      const dayOfWeekMap = {
        'sunday': 0, 'monday': 1, 'tuesday': 2, 'wednesday': 3,
        'thursday': 4, 'friday': 5, 'saturday': 6
      };
      const targetDayIndex = dayOfWeekMap[dayOfWeek];
      const targetDate = new Date(monday);
      targetDate.setDate(monday.getDate() + targetDayIndex);
      return targetDate;
    }
  };
};

// 관리자용 컴포넌트
const AdminDashboard = ({ user, memos = [], onMemoStatusChange, schedules = [] }) => {
  // 오늘 날짜 정보
  const today = new Date();
  const todayDayOfWeek = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'][today.getDay()];
  
  // 오늘의 확정 스케줄 필터링
  const confirmedSchedules = schedules.filter(schedule => 
    schedule.status === 'confirmed' && 
    schedule.studentName && 
    schedule.dayOfWeek === todayDayOfWeek
  );
  
      console.log('🏠 Admin Dashboard - 전체 스케줄:', schedules);
    console.log('🏠 Admin Dashboard - 확정 스케줄:', confirmedSchedules);

  // 읽지 않은 메모 수
  const unreadMemos = memos.filter(memo => 
    memo.status === 'pending' && 
    memo.memoType !== 'pending_memo' // 매칭대기 메모는 제외
  );

  // 사유별 텍스트 매핑
  const getReasonText = (reason) => {
    const reasonMap = {
      'schedule_conflict': '스케줄 충돌',
      'student_request': '학생 요청',
      'personal_matter': '개인 사정',
      'emergency': '긴급 상황',
      'system_error': '시스템 오류',
      'other': '기타'
    };
    return reasonMap[reason] || '기타';
  };

  // 요일 텍스트 변환 함수
  const getDayText = (dayOfWeek) => {
    const dayMap = {
      'monday': '월요일',
      'tuesday': '화요일',
      'wednesday': '수요일',
      'thursday': '목요일',
      'friday': '금요일',
      'saturday': '토요일',
      'sunday': '일요일'
    };
    return dayMap[dayOfWeek] || dayOfWeek;
  };

  const handleMemoRead = async (memoId) => {
    await onMemoStatusChange(memoId, 'read');
  };





  return (
    <div className="admin-dashboard">
      {/* 헤더 */}
      <div className="admin-header">
        <div className="date-info">
          <h1>📊 관리자 대시보드</h1>
          <p className="current-date">{new Date().toLocaleDateString('ko-KR', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            weekday: 'long'
          })}</p>
        </div>
        <div className="admin-summary">
          <div className="summary-item">
            <span className="summary-number">{confirmedSchedules.length}</span>
            <span className="summary-label">확정 수업</span>
          </div>
          <div className="summary-item">
            <span className="summary-number">{unreadMemos.length}</span>
            <span className="summary-label">미확인 메모</span>
          </div>

        </div>
      </div>

      <div className="admin-content">
        {/* 오늘의 확정 스케줄 */}
        <div className="schedule-section">
          <div className="section-header">
            <h3>📅 오늘의 확정 스케줄</h3>
            <span className="schedule-count">총 {confirmedSchedules.length}개 수업</span>
          </div>
          <div className="admin-schedule-grid">
            {confirmedSchedules.length === 0 ? (
              <div className="no-schedules">
                <div className="no-schedules-icon">📅</div>
                <p>오늘 확정된 수업이 없습니다.</p>
                <small>튜터가 스케줄을 등록하고 학생을 배정하면<br />여기에 표시됩니다.</small>
              </div>
            ) : (
              confirmedSchedules.map((schedule) => {
                console.log('🔍 스케줄 데이터:', schedule);
                return (
                <div key={schedule.id} className="admin-schedule-card">
                  <div className="schedule-time">
                    ⏰ {schedule.timeSlot}
                  </div>
                  <div className="schedule-details">
                    <div className="schedule-tutor">
                      👨‍🏫 {schedule.tutorName}
                    </div>
                    <div className="schedule-student">
                      👨‍🎓 {schedule.studentName}
                    </div>
                  </div>
                  <div className="schedule-badges">
                    <div className={`lesson-type-badge ${schedule.lessonType || 'regular'}`}>
                      {schedule.lessonType === 'trial' ? '체험' : '정규'}
                    </div>
                    {schedule.lessonType === 'trial' && schedule.lessonDate && (
                      <div className="lesson-date-badge">
                        {new Date(schedule.lessonDate).toLocaleDateString('ko-KR', { month: 'short', day: 'numeric' })}
                      </div>
                    )}
                  </div>
                </div>
              );
            })
            )}
          </div>
        </div>

        {/* 메모 알림 섹션 */}
        <div className="memo-section">
          <div className="section-header">
            <h3>📝 튜터 메모 알림</h3>
            {unreadMemos.length > 0 && (
              <span className="new-badge">New! {unreadMemos.length}</span>
            )}
          </div>
          
          {unreadMemos.length === 0 ? (
            <div className="no-memos">
              <div className="no-memos-icon">✅</div>
              <p>확인할 새로운 메모가 없습니다.</p>
            </div>
          ) : (
            <div className="memo-list">
              {unreadMemos.map((memo) => (
                <div key={memo.id} className="memo-item">
                  <div className="memo-header">
                    <div className="memo-info">
                      <span className="memo-student">👨‍🎓 {memo.student}</span>
                      {memo.dayOfWeek && (
                        <span className="memo-day">📅 {getDayText(memo.dayOfWeek)}</span>
                      )}
                      <span className="memo-time">⏰ {memo.time}</span>
                      <span className="memo-tutor">👨‍🏫 {memo.tutorName}</span>
                      <div className="memo-badges">
                        <div className={`lesson-type-badge ${memo.lessonType || 'regular'}`}>
                          {memo.lessonType === 'trial' ? '체험' : '정규'}
                        </div>
                        {memo.lessonType === 'trial' && memo.lessonDate && (
                          <div className="lesson-date-badge">
                            {new Date(memo.lessonDate).toLocaleDateString('ko-KR', { month: 'short', day: 'numeric' })}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="memo-date">
                      {memo.timestamp ? 
                        (memo.timestamp.toDate ? 
                          memo.timestamp.toDate().toLocaleDateString('ko-KR') : 
                          new Date(memo.timestamp).toLocaleDateString('ko-KR')
                        ) : 
                        '날짜 정보 없음'
                      }
                    </div>
                  </div>
                  <div className="memo-content">
                    <p><strong>사유:</strong> {getReasonText(memo.reason)}</p>
                    <p><strong>내용:</strong> {memo.memo}</p>
                  </div>
                  <div className="memo-actions">
                    <button 
                      className="memo-read-btn"
                      onClick={() => handleMemoRead(memo.id)}
                    >
                      ✅ 확인 완료
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

// 튜터용 컴포넌트
const TutorDashboard = ({ user, memos, setMemos, isMemoModalOpen, setIsMemoModalOpen, selectedSchedule, setSelectedSchedule, showSuccess, showWarning, schedules }) => {
  // 현재 날짜 정보
  const today = new Date();
  const formatDate = (date) => {
    return date.toLocaleDateString('ko-KR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long'
    });
  };

  const formatTime = (date) => {
    return date.toLocaleTimeString('ko-KR', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // 오늘의 확정 스케줄 필터링 (현재 사용자 것만)
  const todayDayOfWeek = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'][today.getDay()];
  const todaySchedules = schedules.filter(schedule => 
    (schedule.tutorId || '').toLowerCase() === (user.email || '').toLowerCase() && 
    schedule.status === 'confirmed' && 
    schedule.studentName &&
    schedule.dayOfWeek === todayDayOfWeek
  );

  // 현재 사용자의 전체 스케줄 필터링
  const userSchedules = schedules.filter(schedule => 
    (schedule.tutorId || '').toLowerCase() === (user.email || '').toLowerCase()
  );

  // 스케줄 클릭 핸들러 (확정된 스케줄과 매칭대기 스케줄)
  const handleScheduleClick = (schedule, date = '오늘') => {
    console.log('🖱️ 스케줄 클릭됨:', { schedule, date });
    
    if (schedule.status === 'confirmed' || schedule.status === 'registered' || schedule.status === 'pending' || schedule.status === 'pending_with_memo') {
      console.log('✅ 클릭 가능한 스케줄:', schedule.status);
      
      // 실제 날짜 계산
      let actualDate = date;
      if (date === '오늘') {
        actualDate = formatDate(today);
      } else if (schedule.dayOfWeek) {
        // 요일 정보가 있으면 해당 요일의 날짜 계산
        const dayNames = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
        const dayIndex = dayNames.indexOf(schedule.dayOfWeek);
        if (dayIndex !== -1) {
          const todayIndex = today.getDay();
          const daysDiff = dayIndex - todayIndex;
          const targetDate = new Date(today);
          targetDate.setDate(today.getDate() + daysDiff);
          actualDate = formatDate(targetDate);
        }
      }
      
      const scheduleInfo = {
        id: schedule.id,
        time: schedule.timeSlot || `${schedule.time}-${String(Number(schedule.time.split(':')[0]) + 1).padStart(2, '0')}:00`,
        student: schedule.status === 'pending' || schedule.status === 'pending_with_memo' ? '매칭 대기' : schedule.studentName,
        studentName: schedule.studentName,
        status: schedule.status,
        lessonType: schedule.lessonType,
        lessonDate: schedule.lessonDate,
        date: actualDate,
        tutorName: user.name,
        dayOfWeek: schedule.dayOfWeek // 요일 정보 추가
      };
      
      console.log('📋 스케줄 정보:', scheduleInfo);
      setSelectedSchedule(scheduleInfo);
      setIsMemoModalOpen(true);
    } else {
      console.log('❌ 클릭 불가능한 스케줄:', schedule.status);
    }
  };

  // 메모 저장 핸들러
  const handleSaveMemo = async (memoData) => {
    try {
      // 매칭대기 메모인지 확인
      const isPendingMemo = memoData.student === '매칭 대기';
      
      // 1. 메모 저장 (요일 정보 포함)
      await addMemo({
        ...memoData,
        tutorId: user.email,
        tutorName: user.name,
        dayOfWeek: memoData.dayOfWeek, // 요일 정보 추가
        ...(isPendingMemo && { memoType: 'pending_memo' }) // 매칭대기 메모일 때만 memoType 설정
      });
      
      // 2. 스케줄 상태 업데이트
      if (memoData.scheduleId) {
        // 현재 스케줄 정보 찾기
        const currentSchedule = schedules.find(s => s.id === memoData.scheduleId);
        if (currentSchedule) {
          if (isPendingMemo) {
            // 매칭대기 메모인 경우 pending_with_memo로 변경
            await updateScheduleStatus(
              memoData.scheduleId, 
              'pending_with_memo', 
              null, 
              user.email,
              currentSchedule.lessonType,
              currentSchedule.lessonDate
            );
            console.log('✅ 매칭대기 스케줄 상태가 pending_with_memo로 업데이트됨:', memoData.scheduleId);
          } else {
            // 확정 스케줄인 경우 registered로 변경
          await updateScheduleStatus(
            memoData.scheduleId, 
            'registered', 
            null, 
            user.email,
            currentSchedule.lessonType,
            currentSchedule.lessonDate
          );
          console.log('✅ 스케줄 상태가 registered로 업데이트됨:', memoData.scheduleId);
        }
      }
      }
      
      const successMessage = isPendingMemo 
        ? '매칭대기 메모가 저장되었습니다.' 
        : '메모가 저장되었습니다.\n관리자 확인 후 처리 될 예정입니다.';
      
      showSuccess(successMessage);
    } catch (error) {
      console.error('메모 저장 오류:', error);
      showWarning('메모 저장에 실패했습니다. 다시 시도해주세요.');
    }
  };

  // 메모 수정 핸들러
  const handleUpdateMemo = async (memoId, updateData) => {
    try {
      await updateMemo(memoId, updateData);
      showSuccess('메모가 수정되었습니다.');
    } catch (error) {
      console.error('메모 수정 오류:', error);
      showWarning('메모 수정에 실패했습니다. 다시 시도해주세요.');
    }
  };

  // 메모 삭제 핸들러
  const handleDeleteMemo = async (memoId, scheduleId) => {
    try {
      // 1. 메모 삭제
      await deleteMemo(memoId);
      
      // 2. 스케줄 상태를 다시 되돌리기
      if (scheduleId) {
        const currentSchedule = schedules.find(s => s.id === scheduleId);
        if (currentSchedule) {
          if (currentSchedule.status === 'pending_with_memo') {
            // 매칭대기 메모가 있던 스케줄은 pending으로 되돌리기
            await updateScheduleStatus(
              scheduleId, 
              'pending', 
              null, 
              user.email,
              currentSchedule.lessonType,
              currentSchedule.lessonDate
            );
            console.log('✅ 매칭대기 스케줄 상태가 pending으로 되돌아감:', scheduleId);
          } else if (currentSchedule.status === 'registered') {
            // 확정 스케줄은 confirmed로 되돌리기
          await updateScheduleStatus(
            scheduleId, 
            'confirmed', 
            currentSchedule.studentName, 
            user.email,
            currentSchedule.lessonType,
            currentSchedule.lessonDate
          );
          console.log('✅ 스케줄 상태가 confirmed로 되돌아감:', scheduleId);
        }
      }
      }
      
      const successMessage = selectedSchedule?.student === '매칭 대기'
        ? '매칭대기 메모가 삭제되었습니다.'
        : '메모가 삭제되었습니다.\n스케줄이 확정 상태로 되돌아갔습니다.';
      
      showSuccess(successMessage);
    } catch (error) {
      console.error('메모 삭제 오류:', error);
      showWarning('메모 삭제에 실패했습니다. 다시 시도해주세요.');
    }
  };

  // 스케줄에 메모가 있는지 확인하는 함수 (승인 대기 상태와 매칭대기 메모)
  const hasScheduleMemo = (time, student, date) => {
    // 매칭대기 메모인 경우 dayOfWeek로 확인
    if (student === '매칭 대기') {
      // 시간 형식을 확인하고 timeSlot 형식으로 변환
      let timeSlot = time;
      if (!time.includes('-')) {
        // '08:00' 형식이면 '08:00-09:00' 형식으로 변환
        timeSlot = `${time}-${String(Number(time.split(':')[0]) + 1).padStart(2, '0')}:00`;
      }
      
      // 요일 정보 추출
      const dayOfWeek = date.includes('월요일') ? 'monday' :
                       date.includes('화요일') ? 'tuesday' :
                       date.includes('수요일') ? 'wednesday' :
                       date.includes('목요일') ? 'thursday' :
                       date.includes('금요일') ? 'friday' :
                       date.includes('토요일') ? 'saturday' :
                       date.includes('일요일') ? 'sunday' : null;
      
      return memos.some(memo => 
        memo.time === timeSlot && 
        memo.student === student && 
        memo.dayOfWeek === dayOfWeek &&
        memo.memoType === 'pending_memo'
      );
    } else {
      // 확정 스케줄 메모는 기존 방식 (pending 또는 memoType이 없는 메모)
    return memos.some(memo => 
      memo.time === time && 
      memo.student === student && 
        // memo.date === date && // 날짜 조건 제거 (반복 스케줄이므로)
        (memo.status === 'pending' || !memo.memoType) // memoType이 없는 기존 메모도 포함
    );
    }
  };

  // 스케줄의 기존 메모 찾기
  const findExistingMemo = (time, student, date) => {
    console.log('🔍 findExistingMemo 호출:', { time, student, date });
    
    // 매칭대기 메모인 경우 dayOfWeek로 찾기
    if (student === '매칭 대기') {
      // 시간 형식을 확인하고 timeSlot 형식으로 변환
      let timeSlot = time;
      if (!time.includes('-')) {
        // '08:00' 형식이면 '08:00-09:00' 형식으로 변환
        timeSlot = `${time}-${String(Number(time.split(':')[0]) + 1).padStart(2, '0')}:00`;
      }
      
      // 요일 정보 추출 (예: "월요일 (7/29)" -> "monday")
      const dayOfWeek = date.includes('월요일') ? 'monday' :
                       date.includes('화요일') ? 'tuesday' :
                       date.includes('수요일') ? 'wednesday' :
                       date.includes('목요일') ? 'thursday' :
                       date.includes('금요일') ? 'friday' :
                       date.includes('토요일') ? 'saturday' :
                       date.includes('일요일') ? 'sunday' : null;
      
      console.log('🔍 매칭대기 메모 검색 조건:', { timeSlot, dayOfWeek });
      console.log('🔍 전체 메모 목록:', memos);
      
      const foundMemo = memos.find(memo => 
        memo.time === timeSlot && 
        memo.student === student && 
        memo.dayOfWeek === dayOfWeek &&
        memo.memoType === 'pending_memo'
      );
      
      console.log('🔍 찾은 매칭대기 메모:', foundMemo);
      return foundMemo;
    } else {
      // 확정 스케줄 메모는 시간과 학생 이름만으로 찾기 (날짜 제외)
      console.log('🔍 확정 스케줄 메모 검색 조건:', { time, student });
      console.log('🔍 전체 메모 목록:', memos);
      
      // 각 메모를 하나씩 확인
      const matchingMemos = memos.filter(memo => {
        console.log('🔍 메모 확인:', {
          memo_time: memo.time,
          memo_student: memo.student,
          memo_status: memo.status,
          memo_memoType: memo.memoType,
          time_match: memo.time === time,
          student_match: memo.student === student,
          status_condition: memo.status === 'pending' || !memo.memoType
        });
        
        return memo.time === time && 
      memo.student === student && 
               // memo.date === date && // 날짜 조건 제거
               (memo.status === 'pending' || !memo.memoType);
      });
      
      console.log('🔍 조건에 맞는 메모들:', matchingMemos);
      
      const foundMemo = matchingMemos[0] || null;
      
      console.log('🔍 찾은 확정 스케줄 메모:', foundMemo);
      return foundMemo;
    }
  };

  // 매칭대기 메모의 불가능한 날짜 확인
  const getUnavailableDates = (time, dayOfWeek) => {
    // 시간 형식을 확인하고 timeSlot 형식으로 변환
    let timeSlot = time;
    if (!time.includes('-')) {
      // '08:00' 형식이면 '08:00-09:00' 형식으로 변환
      timeSlot = `${time}-${String(Number(time.split(':')[0]) + 1).padStart(2, '0')}:00`;
    }
    
    const pendingMemo = memos.find(memo => 
      memo.time === timeSlot && 
      memo.student === '매칭 대기' && 
      memo.dayOfWeek === dayOfWeek &&
      memo.memoType === 'pending_memo'
    );
    
    // 다중 날짜 지원 (새 데이터) 또는 단일 날짜 (기존 데이터)
    return pendingMemo?.unavailableDates || (pendingMemo?.unavailableDate ? [pendingMemo.unavailableDate] : []);
  };


  // 전체 시간대 정의 (08:00 ~ 22:00)
  const allTimeSlots = [
    '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', 
    '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', 
    '20:00', '21:00', '22:00'
  ];

  // 요일 정의
  const weekDays = [
    { short: '월', full: '월요일', name: 'monday' },
    { short: '화', full: '화요일', name: 'tuesday' },
    { short: '수', full: '수요일', name: 'wednesday' },
    { short: '목', full: '목요일', name: 'thursday' },
    { short: '금', full: '금요일', name: 'friday' },
    { short: '토', full: '토요일', name: 'saturday' },
    { short: '일', full: '일요일', name: 'sunday' }
  ];

  // 요일별 스케줄 그룹핑 (실제 데이터 기반)
  const groupedSchedules = userSchedules.reduce((acc, schedule) => {
    const dayName = schedule.dayOfWeek;
    if (!acc[dayName]) {
      acc[dayName] = {};
    }
    acc[dayName][schedule.timeSlot] = schedule;
    return acc;
  }, {});

  // 각 요일의 전체 시간대 생성 (빈 시간대 포함)
  const generateDaySchedules = (dayData, dayName) => {
    return allTimeSlots.map(time => {
      const timeSlot = `${time}-${String(Number(time.split(':')[0]) + 1).padStart(2, '0')}:00`;
      const schedule = dayData?.[timeSlot];
      if (schedule) {
        return {
          ...schedule,
          time: time,
          student: schedule.studentName,
          dayOfWeek: dayName // 요일 정보 추가
        };
      } else {
        return {
          time: time,
          status: 'empty',
          student: null,
          dayOfWeek: dayName // 빈 시간대에도 요일 정보 추가
        };
      }
    });
  };

  return (
    <div className="home-container">
      {/* 헤더 */}
      <div className="home-header">
        <div className="date-info">
          <h1>{formatDate(today)}</h1>
          <p className="current-time">현재 시간: {formatTime(today)}</p>
        </div>
        <div className="welcome-message">
          <h2>안녕하세요, {user.name}님! 👋</h2>
          <p>오늘의 스케줄을 확인해보세요.</p>
        </div>

      </div>

      {/* 메인 컨텐츠 */}
      <div className="home-content">
        {/* 오늘의 확정 스케줄 */}
        <div className="schedule-section">
          <div className="section-header">
            <h3>🗓️ 오늘의 확정 스케줄</h3>
            <span className="schedule-count">{todaySchedules.length}개 수업</span>
          </div>
          <div className="schedule-grid">
            {todaySchedules.map((schedule) => {
              const hasMemo = hasScheduleMemo(schedule.timeSlot, schedule.studentName, '오늘');
              return (
              <div 
                  key={schedule.id} 
                  className={`schedule-card confirmed clickable ${hasMemo ? 'has-memo' : ''}`}
                  onClick={() => handleScheduleClick(schedule, '오늘')}
                  title={hasMemo ? '메모가 있는 스케줄 (클릭하여 확인)' : '클릭하여 메모 작성'}
              >
                <div className="schedule-time">
                  ⏰ {schedule.timeSlot}
                </div>
                <div className="schedule-student">
                  👨‍🎓 {schedule.studentName}
                </div>
                <div className="schedule-badges">
                  <div className={`lesson-type-badge ${schedule.lessonType || 'regular'}`}>
                    {schedule.lessonType === 'trial' ? '체험' : '정규'}
                  </div>
                  {schedule.lessonType === 'trial' && schedule.lessonDate && (
                    <div className="lesson-date-badge">
                      {new Date(schedule.lessonDate).toLocaleDateString('ko-KR', { month: 'short', day: 'numeric' })}
                    </div>
                  )}
                </div>
                <div className="memo-hint">
                  {hasMemo ? '📋 메모 확인' : '📝 메모 작성'}
                </div>
              </div>
              );
            })}
          </div>
        </div>

        {/* 이번 주 스케줄 캘린더 */}
        <div className="calendar-section">
          <div className="section-header">
            <h3>📅 이번 주 전체 스케줄</h3>
            <div className="calendar-legend">
              <div className="legend-item">
                <span className="legend-dot empty"></span>
                <span>빈 시간</span>
              </div>
              <div className="legend-item">
                <span className="legend-dot pending"></span>
                <span>매칭 대기</span>
              </div>
              <div className="legend-item">
                <span className="legend-dot pending-memo"></span>
                <span>매칭 대기 메모 등록</span>
              </div>
              <div className="legend-item">
                <span className="legend-dot confirmed"></span>
                <span>확정 완료</span>
              </div>
              <div className="legend-item">
                <span className="legend-dot has-memo"></span>
                <span>메모 등록</span>
              </div>
              <div className="legend-item">
                <span className="legend-badge regular">정규</span>
                <span>정규수업</span>
              </div>
              <div className="legend-item">
                <span className="legend-badge trial">체험</span>
                <span>체험수업</span>
              </div>
            </div>
          </div>
          
          <div className="weekly-calendar">
            {weekDays.map(day => {
              // 공통 날짜 계산 함수 사용 (관리자와 동일한 기준)
              const { weekDates, formatDate } = getWeekCalculation();
              const dayId = day.name; // monday, tuesday, ... 
              const targetDate = weekDates[dayId];
              const dayDate = targetDate.getDate();
              
              const dayData = groupedSchedules[day.name];
              const daySchedules = generateDaySchedules(dayData, day.name);
              const confirmedCount = daySchedules.filter(s => s.status === 'confirmed').length;
              const pendingCount = daySchedules.filter(s => s.status === 'pending').length;
              const emptyCount = daySchedules.filter(s => s.status === 'empty').length;
              
              return (
                <div key={day.short} className="calendar-day">
                  <div className="day-header">
                    <div className="day-full-name">{day.full}</div>
                    <div className="day-date">{dayDate}</div>
                    <div className="day-summary">
                      {confirmedCount > 0 && <span className="confirmed-badge">{confirmedCount}</span>}
                      {pendingCount > 0 && <span className="pending-badge">{pendingCount}</span>}
                      {emptyCount > 0 && <span className="empty-badge">{emptyCount}</span>}
                    </div>
                  </div>
                  
                  <div className="day-schedules">
                    {daySchedules.map((schedule, index) => {
                      const hasMemo = (schedule.status === 'confirmed' || schedule.status === 'pending' || schedule.status === 'pending_with_memo') && 
                        hasScheduleMemo(schedule.time, schedule.status === 'pending' || schedule.status === 'pending_with_memo' ? '매칭 대기' : schedule.student, `${day.short}요일 (${dayDate})`);
                      
                      // 매칭대기 메모의 불가능한 날짜들 확인
                      const unavailableDates = (schedule.status === 'pending' || schedule.status === 'pending_with_memo') ? 
                        getUnavailableDates(schedule.time, schedule.dayOfWeek) : [];
                      
                      // 현재 날짜가 불가능한 날짜 중 하나인지 확인
                      const isUnavailableDate = unavailableDates.some(unavailableDate => {
                        try {
                          // unavailableDate를 Date 객체로 변환
                          const unavailableDateObj = new Date(unavailableDate);
                          
                          // dayDate에서 월/일 추출 (dayDate가 숫자인 경우 문자열로 변환)
                          const dayDateStr = String(dayDate);
                          const dayDateParts = dayDateStr.includes('/') ? dayDateStr.split('/') : null;
                          
                          if (dayDateParts && dayDateParts.length === 2) {
                            const month = parseInt(dayDateParts[0]);
                            const day = parseInt(dayDateParts[1]);
                            
                            // unavailableDate의 월/일과 비교
                            return unavailableDateObj.getMonth() + 1 === month && 
                                   unavailableDateObj.getDate() === day;
                          } else {
                            // dayDate가 단순 숫자인 경우 (예: 28) 현재 달과 비교
                            const currentMonth = today.getMonth() + 1;
                            const dayNum = parseInt(dayDateStr);
                            
                            return unavailableDateObj.getMonth() + 1 === currentMonth && 
                                   unavailableDateObj.getDate() === dayNum;
                          }
                        } catch (error) {
                          console.error('날짜 비교 오류:', error);
                          return false;
                        }
                      });
                      
                      // 불가능 날짜가 있는 pending은 'pending_with_memo'와 동일하게 표시
                      const normalizedStatus = (schedule.status === 'pending' && isUnavailableDate)
                        ? 'pending_with_memo'
                        : schedule.status;

                      return (
                      <div 
                        key={index} 
                        className={`schedule-item ${normalizedStatus} ${(normalizedStatus === 'confirmed' || normalizedStatus === 'registered' || normalizedStatus === 'pending' || normalizedStatus === 'pending_with_memo') ? 'clickable' : ''} ${hasMemo ? 'has-memo' : ''}`}
                        onClick={() => (normalizedStatus === 'confirmed' || normalizedStatus === 'registered' || normalizedStatus === 'pending' || normalizedStatus === 'pending_with_memo') && handleScheduleClick(schedule, `${day.short}요일 (${dayDate})`)}
                          title={
                            (normalizedStatus === 'confirmed' || normalizedStatus === 'registered' || normalizedStatus === 'pending' || normalizedStatus === 'pending_with_memo') ? 
                              (normalizedStatus === 'registered' || normalizedStatus === 'pending_with_memo' ? '메모가 있는 스케줄 (클릭하여 수정/삭제)' : 
                               (hasMemo ? '메모가 있는 스케줄 (클릭하여 확인)' : '클릭하여 메모 작성')) : ''
                            }
                      >
                        <div className="schedule-time-small">{schedule.time}</div>
                        {schedule.student && (
                          <div className="schedule-student-small">{schedule.student}</div>
                        )}
                        {(normalizedStatus === 'confirmed' || normalizedStatus === 'registered') && (
                          <div className="schedule-badges-small">
                            <div className={`lesson-type-badge-small ${schedule.lessonType || 'regular'}`}>
                              {schedule.lessonType === 'trial' ? '체험' : '정규'}
                            </div>
                            {schedule.lessonType === 'trial' && schedule.lessonDate && (
                              <div className="lesson-date-badge-small">
                                {new Date(schedule.lessonDate).toLocaleDateString('ko-KR', { month: 'short', day: 'numeric' })}
                              </div>
                            )}
                          </div>
                        )}
                          {!schedule.student && (normalizedStatus === 'pending' || normalizedStatus === 'pending_with_memo') && (
                            <div className="schedule-waiting">
                              {normalizedStatus === 'pending_with_memo' ? '매칭 대기 메모 등록' : '매칭 대기'}
                            </div>
                        )}
                        {schedule.status === 'empty' && (
                          <div className="schedule-empty">-</div>
                        )}
                        {(normalizedStatus === 'confirmed' || normalizedStatus === 'registered' || normalizedStatus === 'pending' || normalizedStatus === 'pending_with_memo') && (
                            <div className="memo-icon">
                              {(normalizedStatus === 'registered' || normalizedStatus === 'pending_with_memo') ? '📋' : (hasMemo ? '📋' : '📝')}
                            </div>
                        )}
                      </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>

          {/* 메모 안내 섹션 */}
          <div className="memo-notice">
            <div className="notice-content">
              <div className="notice-icon">📝</div>
              <div className="notice-text">
                <h4>스케줄 변경 메모 안내</h4>
                <p>확정된 스케줄(초록색)을 클릭하면 변경 사유나 특이사항을 메모로 남길 수 있습니다. 작성된 메모는 관리자가 확인할 수 있습니다.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 스케줄 메모 모달 */}
      <ScheduleMemoModal
        isOpen={isMemoModalOpen}
        onClose={() => setIsMemoModalOpen(false)}
        scheduleInfo={selectedSchedule}
        onSaveMemo={handleSaveMemo}
        onUpdateMemo={handleUpdateMemo}
        onDeleteMemo={handleDeleteMemo}
        showWarning={showWarning}
        existingMemo={selectedSchedule ? findExistingMemo(selectedSchedule.time, selectedSchedule.student, selectedSchedule.date) : null}
      />
    </div>
  );
};

// 메인 Home 컴포넌트
const Home = ({ user }) => {
  const { alertState, showSuccess, showError, showWarning, showConfirm, showInfo } = useCustomAlert();
  
  // 공통 state
  const [memos, setMemos] = useState([]);
  const [schedules, setSchedules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Firebase 실시간 구독 설정
  useEffect(() => {
    let unsubscribeSchedules;
    let unsubscribeMemos;

    const setupSubscriptions = () => {
      // 스케줄 실시간 구독
      unsubscribeSchedules = subscribeToSchedules((schedulesData) => {
        setSchedules(schedulesData);
        setLoading(false);
      }, (err) => {
        setError('스케줄 데이터를 불러오지 못했습니다.');
        setLoading(false);
      });

      // 메모 실시간 구독
      unsubscribeMemos = subscribeToMemos((memosData) => {
        setMemos(memosData);
      }, (err) => {
        setError('메모 데이터를 불러오지 못했습니다.');
      });
    };

    setupSubscriptions();

    // 컴포넌트 언마운트 시 구독 해제
    return () => {
      if (unsubscribeSchedules) unsubscribeSchedules();
      if (unsubscribeMemos) unsubscribeMemos();
    };
  }, []);

  // 튜터용 state (관리자는 사용하지 않음)
  const [isMemoModalOpen, setIsMemoModalOpen] = useState(false);
  const [selectedSchedule, setSelectedSchedule] = useState(null);

  // 메모 상태 변경 핸들러 (관리자용)
  const handleMemoStatusChange = async (memoId, newStatus) => {
    try {
      // Firestore에 메모 상태 업데이트
      await updateMemoStatus(memoId, newStatus, user.name);
      
      // 로컬 상태도 업데이트 (실시간 구독으로 자동 업데이트되지만 즉시 반영을 위해)
      setMemos(prev => 
        prev.map(memo => 
          memo.id === memoId ? { ...memo, status: newStatus } : memo
        )
      );
      
      console.log('✅ 메모 상태 업데이트 완료:', memoId, newStatus);
    } catch (error) {
      console.error('메모 상태 업데이트 오류:', error);
      showError('메모 상태 업데이트에 실패했습니다. 다시 시도해주세요.');
    }
  };

  // 로딩 중일 때 아무것도 표시하지 않음
  if (loading) return null;

  // 에러 발생 시 에러 메시지 표시
  if (error) {
    return <div className="error-message">{error}</div>;
  }

  // 역할에 따라 다른 대시보드 렌더링
  if (user.role === 'admin') {
    return (
      <>
        <AdminDashboard 
          user={user} 
          memos={memos}
          schedules={schedules}
          onMemoStatusChange={handleMemoStatusChange}
        />
        <CustomAlert {...alertState} />
      </>
    );
  } else {
    return (
      <>
        <TutorDashboard 
          user={user}
          memos={memos}
          schedules={schedules}
          setMemos={setMemos}
          isMemoModalOpen={isMemoModalOpen}
          setIsMemoModalOpen={setIsMemoModalOpen}
          selectedSchedule={selectedSchedule}
          setSelectedSchedule={setSelectedSchedule}
          showSuccess={showSuccess}
          showWarning={showWarning}
        />
        <CustomAlert {...alertState} />
      </>
    );
  }
};

export default Home; 